// export const updateFilter               = 'listParkingSpace/updateFilter';
export const toPayment = 'listParkingSpace/toPayment';
export const saveFilter = 'listParkingSpace/saveFilter';
export const homeSearch = 'listParkingSpace/homeSearch';
